import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './coupon.css';
function Coupon({ datas, setOpenModals }) {
	const [sucessCopy, setSucessCopy] = useState(false);
	const textCopy = (txt) => {
		var dummy = document.createElement('textarea');
		document.body.appendChild(dummy);
		dummy.value = txt;
		dummy.select();
		document.execCommand('copy');
		document.body.removeChild(dummy);
		setSucessCopy(true);
		toast.success('Coupon Code copied to clipboard', {
			position: 'bottom-center',
			autoClose: 1000,
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: 'colored',
			bottom: '26px',
			width: '79%',
			left: '45px',
		});
	};

	return (
		<>
			<div className="couponRewardCard">
				{datas?.id != 44 ?
					<>
						<img src={datas?.logo} alt="" width={121}/>
						<p>{datas?.winningText + ' ' + datas?.spinText}</p>
						<div className="rewardCopyFlex">
							<h4><span>Your voucher code</span>{datas?.code}</h4>
							<button onClick={() => textCopy(datas?.code)}>Copy</button>
						</div>
					</>	:
					<div className="nextTimeText">Better Luck Next Time</div>
				}
			</div>
			{sucessCopy &&
				<ToastContainer
					position="bottom-center"
					autoClose={2000}
					hideProgressBar={false}
					newestOnTop={false}
					// closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
					theme="colored"
					bottom="26px"
					width="79%"
					left="45px"
				/>
			}
		</>

	);
}

export default Coupon;
